import { put, takeEvery } from '@redux-saga/core/effects';
import {
	handleActionFailed,
	handleActionRequested,
	handleActionSucceeded,
	showMessage,
} from '../app';
import { BASE_URL, ENDPOINTS } from '../../api/endpoint';
import { AxiosResponse } from 'axios';
import { Requests } from '../../api/requests';
import { all, fork } from 'redux-saga/effects';
import { IResponseUpdateHospital, IUpdateHospitalAction } from './updateHospital.interface';
import { UpdateHospitalTypes } from './updateHospital.type';

function* updateHospital({ type, payload }: IUpdateHospitalAction) {
	yield put(handleActionRequested(type));

	try {
		const apiUrl = BASE_URL.dev + ENDPOINTS.hospitals + '/' + payload.id;
		const response: AxiosResponse = yield Requests.put(apiUrl, { name: payload.name });
		if (response.data) {
			yield put(handleActionSucceeded<IResponseUpdateHospital>(type, response.data));
			yield put(showMessage('Cập nhật tên ngân hàng sữa mẹ thành công', 'success'));
		} else {
			yield put(handleActionFailed(type, ''));
		}
	} catch (error: any) {
		const message = error.response.data.message ? error.response.data.message : error.message;
		yield put(handleActionFailed(type, message));
	}
}

function* watchUpdateHospital() {
	yield takeEvery(UpdateHospitalTypes.UPDATE_HOSPITAL, updateHospital);
}

export function* rootUpdateHospital() {
	yield all([fork(watchUpdateHospital)]);
}
